export const styles = (theme) => ({
  table: {
    minWidth: 650,
    "& td:first-child": {
      position: "initial",
      left: "inherit"
    }
  },
  tableHeader: {
    backgroundColor: "#F7F7F7",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderStyle: "solid",
  },
  columnHeader: {
    backgroundColor: "#F7F7F7",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderStyle: "solid",
    width: "250px"
  },
});